<template>
    <!-- Add Shipping Modal -->
    <div
        class="modal fade custom-modal"
        id="addShippingModal"
        ref="addShippingModal"
        tabindex="-1"
        aria-labelledby="shippingModalLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-lg"
            style="max-width: 900px"
        >
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="shippingModalLabel">
                        <template v-if="shipping != null">Edit</template
                        ><template v-else>Add</template> Shipping
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                <div class="modal-body">
                    <div
                        class="alert alert-success"
                        role="alert"
                        v-if="successMessage"
                    >
                        {{ successMessage }}
                    </div>

                    <div
                        v-if="commonErrors.length != 0"
                        class="alert alert-danger alert-dismissible"
                    >
                        <a
                            href="javascript:void(0);"
                            class="close"
                            data-dismiss="alert"
                            aria-label="close"
                            >&times;</a
                        >
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p
                                    v-for="error in v"
                                    :key="error"
                                    class="text-sm"
                                >
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver
                        v-slot="{ handleSubmit }"
                        ref="formValidation"
                        name="addShipping"
                    >
                        <form
                            @submit.prevent="handleSubmit(submitHandler)"
                            enctype="multipart/form-data"
                        >
                            <div class="invoiceDetails">
                                <table class="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th style="width: 70px">
                                                <div
                                                    class="custom-control custom-checkbox"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        id="checkAll"
                                                        name="checkAll"
                                                        v-model="checkAll"
                                                        v-on:click="
                                                            checkAllEvent(
                                                                $event
                                                            )
                                                        "
                                                    />
                                                    <label
                                                        class="custom-control-label"
                                                        for="checkAll"
                                                        >All</label
                                                    >
                                                </div>
                                            </th>
                                            <th style="width: 120px">Item #</th>
                                            <th>Product Name</th>
                                            <th style="width: 260px">
                                                Quantity
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                product, index
                                            ) in form.products.filter(
                                                (x) => x.id != null
                                            )"
                                            :key="product.id"
                                        >
                                            <td>
                                                <div
                                                    class="custom-control2 custom-checkbox2"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input2"
                                                        :value="product.id"
                                                        :id="'id_' + product.id"
                                                        name="uns_prod_ids[]"
                                                        :checked="true"
                                                        @click="
                                                            removeProductCheckbox(
                                                                product,
                                                                $event
                                                            )
                                                        "
                                                    />
                                                    <!-- <label
                                                        class="custom-control-label"
                                                        :for="
                                                            'id_' + product.id
                                                        "
                                                    ></label> -->
                                                    
                                                </div>
                                            </td>
                                            <td>
                                                <router-link
                                                    :to="{
                                                        name: 'productsDetails',
                                                        params: {
                                                            id: product.id,
                                                        },
                                                    }"
                                                    target="_blank"
                                                    >{{
                                                        product.product_num
                                                    }}</router-link
                                                >
                                            </td>
                                            <td>
                                                {{ product.product_name }}
                                                <p
                                                    v-html="
                                                        product.product_desc
                                                    "
                                                ></p>
                                            </td>
                                            <td>
                                                <ValidationProvider
                                                    name="Quantity"
                                                    immediate
                                                    rules="required|positive|min_value:1"
                                                    v-slot="{ errors }"
                                                >

                                                <template v-if="form.products[index].qty_unit.name == 'M Bags' || form.products[index].qty_unit.name == 'M Impressions'">
                                                <input
                                                        type="text"
                                                        class="form-control form-custom"
                                                        placeholder=""
                                                        v-on:keydown="
                                                            checkNumber($event)
                                                        "
                                                        v-model="
                                                            form.products[index]
                                                                .quantity
                                                        "
                                                    />
                                                </template>
                                                <template v-else>
                                                    <input
                                                        type="text"
                                                        class="form-control form-custom"
                                                        placeholder=""
                                                        v-on:keydown="
                                                            checkNumber($event)
                                                        "
                                                        v-model="
                                                            form.products[index]
                                                                .quantity
                                                        "
                                                    />
                                                </template>
                                                    
                                                    <div
                                                        class="error"
                                                        v-if="errors.length"
                                                    >
                                                        {{ errors[0] }}
                                                    </div>
                                                </ValidationProvider>

                                                <div class="row mt-2">
                                                    <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Pcs Per Case</label
                                                        >
                                                        <input
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            @input="
                                                                checkCaseNumber(
                                                                    index
                                                                )
                                                            "
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ].pcs_per_case
                                                            "
                                                        />
                                                    </div>
                                                    <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Cases Per
                                                            pallet</label
                                                        >
                                                        <input
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            @input="
                                                                checkCaseNumber(
                                                                    index
                                                                )
                                                            "
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ]
                                                                    .cases_per_pallet
                                                            "
                                                        />
                                                    </div>

                                                    <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Amount of Case</label
                                                        >
                                                        <input readonly
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            v-on:keydown="
                                                                checkNumber(
                                                                    $event
                                                                )
                                                            "
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ]
                                                                    .total_cases
                                                            "
                                                        />
                                                    </div>

                                                    <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Amount Of
                                                            pallet</label
                                                        >
                                                        <input readonly
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            @input="
                                                                checkPerAmount(
                                                                    index
                                                                )
                                                            "
                                                            
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ]
                                                                    .amount_pallet
                                                            "
                                                        />
                                                    </div>

                                                    <!-- <div class="col-6">
                                                        <label
                                                            class="form-label"
                                                            >Total Amount pallet</label
                                                        >
                                                        <input
                                                            type="text"
                                                            class="form-control form-custom"
                                                            placeholder=""
                                                            v-on:keydown="
                                                                checkNumber(
                                                                    $event
                                                                )
                                                            "
                                                            v-model="
                                                                form.products[
                                                                    index
                                                                ]
                                                                    .total_amount_pallet
                                                            "
                                                        />
                                                    </div> -->

                                                </div>
                                            </td>
                                        </tr>
                                        <tr
                                            v-for="(
                                                product, index
                                            ) in po.products.filter(
                                                (x) =>
                                                    x.id != null &&
                                                    form.products.filter(
                                                        (y) => y.id === x.id
                                                    ).length === 0
                                            )"
                                            :key="product.id"
                                        >
                                            <td>
                                                <div
                                                    class="custom-control2 custom-checkbox2"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input2"
                                                        :value="product.id"
                                                        :id="'id_' + product.id"
                                                        name="uns_prod_ids[]"
                                                        :checked="false"
                                                        @click="
                                                            selectProductCheckbox(
                                                                product,
                                                                $event
                                                            )
                                                        "
                                                    />
                                                    <!--<label
                                                        class="custom-control-label"
                                                        :for="
                                                            'id_' + product.id
                                                        "
                                                    ></label>-->
                                                </div>
                                            </td>
                                            <td>
                                                <router-link
                                                    :to="{
                                                        name: 'productsDetails',
                                                        params: {
                                                            id: product.id,
                                                        },
                                                    }"
                                                    target="_blank"
                                                    >{{
                                                        product.product_num
                                                    }}</router-link
                                                >
                                            </td>
                                            <td>
                                                {{ product.product_name }}
                                                <p
                                                    v-html="
                                                        product.product_desc
                                                    "
                                                ></p>
                                            </td>
                                            <td>
                                           <template v-if="product.qty_unit.name == 'M Bags' || product.qty_unit.name == 'M Impressions'">
                                            {{ product.quantity * 1000 }}
                                           </template>
                                           <template v-else>
                                            {{ product.quantity }}
                                           </template>

                                                
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="
                                                    form.is_partially_shipped
                                                "
                                            />
                                            <label class="form-check-label"
                                                >Partially Shipped</label
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6"></div>
                            </div>

                            <div class="row">
                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Total Pallets</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Type"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <input 
                                                type="text"
                                                class="form-control form-custom"
                                                placeholder=""
                                                v-on:keydown="
                                                    checkNumber(
                                                        $event
                                                    )
                                                "
                                                v-model="
                                                    form.total_pallet_count
                                                "
                                            />
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                </div>
                            <div class="row">
                                <!-- <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Total Pallets</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Type"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <input readonly
                                                type="text"
                                                class="form-control form-custom"
                                                placeholder=""
                                                v-on:keydown="
                                                    checkNumber(
                                                        $event
                                                    )
                                                "
                                                v-model="
                                                    form.total_pallet_count
                                                "
                                            />
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div> -->

                                

                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Shipping Method</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Type"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                class="form-select"
                                                v-model="form.carrier_type"
                                            >
                                                <!-- <option value="3">Partial By Air – Air</option>
                                                <option value="1">Full order by air</option>
                                                <option value="2">Full Shipment by Sea</option> -->
                                                <option value="1">Air</option>
                                                <option value="2">
                                                    Occean
                                                </option>
                                            </select>
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Shipping Type</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Type"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                class="form-select"
                                                v-model="form.shipping_type"
                                            >
                                                <template
                                                    v-if="
                                                        shippingTypeOptions.length >
                                                        0
                                                    "
                                                >
                                                    <template
                                                        v-for="(
                                                            shippingTypeOption,
                                                            index
                                                        ) in shippingTypeOptions"
                                                    >
                                                        <option
                                                            :value="
                                                                shippingTypeOption
                                                            "
                                                        >
                                                            {{
                                                                shippingTypeOption
                                                            }}
                                                        </option>
                                                    </template>
                                                </template>
                                                <!-- <option value="FCL">FCL</option>
                                                <option value="LCL">LCL</option>
                                                <option value="Parcel">Parcel</option> -->
                                            </select>
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label">{{
                                            tracking_no_label
                                        }}</label>
                                        <ValidationProvider
                                            name="Tracking No"
                                            
                                            v-slot="{ errors }"
                                        >
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.tracking_no"
                                            />
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >HBL</label
                                        >
                                        <ValidationProvider
                                            name="mbl_number"
                                            
                                            v-slot="{ errors }"
                                        >
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.hbl_number"
                                            />
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-3 carrier-select-new">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Carrier</label
                                        >
                                        <template v-if="form.carrier_type == 1">
                                            <ValidationProvider
                                            name="Carrier Type"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <input 
                                                type="text"
                                                class="form-control form-custom"
                                                placeholder=""
                                                
                                                v-model="form.carrier_company"
                                            />
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                            </ValidationProvider>
                                        </template>
                                        <template v-else>
                                            <ValidationProvider
                                            name="Carrier Company"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <v-select
                                                label="name"
                                                :searchable="false"
                                                :filterable="false"
                                                v-model="form.carrier_company"
                                                :options="carriers"
                                                :reduce="
                                                    (option) => option.name
                                                "
                                            >
                                                <template slot="no-options">
                                                    type to search carrier..
                                                </template>
                                                <template
                                                    slot="option"
                                                    slot-scope="option"
                                                >
                                                    <div
                                                        class="d-center"
                                                        v-html="option.name"
                                                    ></div>
                                                </template>
                                                <template
                                                    slot="selected-option"
                                                    slot-scope="option"
                                                >
                                                    <div
                                                        class="selected d-center"
                                                        v-html="option.name"
                                                    ></div>
                                                </template>
                                            </v-select>

                                            <!-- <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.carrier_company"
                                            /> -->
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                        </template>
                                        
                                    </div>
                                </div>
                                <!--<div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Tracking URL</label>
                                        <input type="text" class="form-control" v-model="form.tracking_url" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Shipment Type</label>
                                        <ValidationProvider name="Carrier Type" rules="required" v-slot="{ errors }">
                                            <select class="form-select" v-model="form.shipment_type">
                                                <option value="1">Vendor To Warehouse</option>
                                                <option value="2">Warehouse to Customer</option>
                                                <option value="3">Vendor to Customer</option>
                                            </select> <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>-->
                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label">Status</label>
                                        <select
                                            class="form-select"
                                            v-model="form.status"
                                        >
                                            <option value="1">
                                                Not initiated
                                            </option>
                                            <option value="2">Shipped</option>
                                            <option value="3">
                                                In Transit
                                            </option>
                                            <option value="4">Delivered</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label">ETD</label>
                                        <ValidationProvider
                                            name="ETD"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <date-picker
                                                v-model="form.etd"
                                                valueType="format"
                                                format="MM/DD/YYYY"
                                            ></date-picker>
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <label class="form-label">ETA</label>
                                        <ValidationProvider
                                            name="ETA"
                                            rules="required"
                                            v-slot="{ errors }"
                                            format="MM/DD/YYYY"
                                        >
                                            <date-picker
                                                v-model="form.eta"
                                                valueType="format"
                                            ></date-picker>
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="col-md-3 carrier-select-new">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Superb Warehouse</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Company"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <v-select
                                                @input="(value) => warehouseChange(value, 'warehouses')"
                                                label="name"
                                                :filterable="true"
                                                v-model="form.company_warehouse"
                                                :options="companyWarehouse"
                                                :reduce="
                                                    (option) => option.id
                                                "
                                            >
                                                <template slot="no-options">
                                                    type to Superb Warehouse..
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.name }}
                                                            
                                                        </div>
                                                    <!-- <template v-if="option.warehouse != null">
                                                        <div class="d-center">
                                                            {{ option.address }}
                                                        </div>
                                                    </template> -->
                                                    
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                    <!-- <template v-if="option.warehouse != null">
                                                        <div class="selected d-center">
                                                            {{ option.warehouse.address }}
                                                        </div>
                                                    </template> -->
                                                    <div class="selected d-center">
                                                            {{ option.name }}
                                                            <!-- {{ option.state }} 
                                                                {{ option.city }}  -->
                                                        </div>
                                                    </template>
                                            </v-select>

                                            <!-- <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.carrier_company"
                                            /> -->
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="col-md-3 carrier-select-new">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Customer Warehouse</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Company"
                                            
                                            v-slot="{ errors }"
                                        >
                                            <v-select
                                                 @input="(value) => warehouseChange(value, 'billTo')"
                                                label="text"
                                                :filterable="true"
                                                v-model="form.customer_warehouse"
                                                :options="bill_to_options"
                                                :reduce="
                                                    (option) => option.id
                                                "
                                            >
                                                <template slot="no-options">
                                                    type to Customer Warehouse..
                                                </template>
                                                <template
                                                    slot="option"
                                                    slot-scope="option"
                                                >
                                                    <div
                                                        class="d-center"
                                                        v-html="option.text"
                                                    ></div>
                                                </template>
                                                <template
                                                    slot="selected-option"
                                                    slot-scope="option"
                                                >
                                                    <div
                                                        class="selected d-center"
                                                        v-html="option.text"
                                                    ></div>
                                                </template>
                                            </v-select>

                                            <!-- <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.carrier_company"
                                            /> -->
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="col-md-3 carrier-select-new">
                                    <div class="mt-3">
                                        <label class="form-label"
                                            >Final Destination</label
                                        >
                                        <ValidationProvider
                                            name="Carrier Company"
                                            
                                            v-slot="{ errors }"
                                        >
                                            

                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.final_destination"
                                            />
                                            <div
                                                class="error"
                                                v-if="errors.length"
                                            >
                                                {{ errors[0] }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <!--
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Expected time of Departure</label>
                                        <date-picker v-model="form.eta_departure" format="MM/DD/YYYY" valueType="format"></date-picker>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Expected time of Arrival</label>
                                        <date-picker v-model="form.eta_arrival" format="MM/DD/YYYY" valueType="format"></date-picker>
                                    </div>
                                </div>-->
                            </div>
                            <!--
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Customer</label>
                                        <CustomerSelect :customer="form.customer" :multiple="false" @customerSelectedEvent="customerSelected"></CustomerSelect>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Vendor</label>
                                        <VendorSelect :vendor="form.vendor" :multiple="false" @vendorSelectedEvent="vendorSelected"></VendorSelect>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-3">
                                        <label class="form-label">Source Address</label>
                                        <textarea class="form-control" style="height: 80px" v-model="form.source"></textarea>
                                    </div>
                                </div>
                            </div>
                            -->
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-label"
                                        >Delivered to</label
                                    >
                                    <!-- <select>
                                        <template v-if="order.warehouses">
                                            <option>
                                                <ul
                                                    v-for="(
                                                        item, index
                                                    ) in order.warehouses"
                                                >
                                                    <li v-if="index > 0">
                                                        <hr />
                                                    </li>
                                                    <template
                                                        v-if="item.warehouse"
                                                    >
                                                        <li>
                                                            {{ item.warehouse }}
                                                            {{
                                                                item.warehouse
                                                                    .address2
                                                            }}
                                                        </li>
                                                        <li>
                                                            {{
                                                                item.warehouse
                                                                    .address
                                                            }}
                                                        </li>
                                                        <li>
                                                            {{
                                                                item.warehouse
                                                                    .state
                                                            }}
                                                        </li>
                                                        <li>
                                                            {{
                                                                item.warehouse
                                                                    .city
                                                            }}
                                                        </li>
                                                        <li>
                                                            {{
                                                                item.warehouse
                                                                    .post_code
                                                            }}
                                                        </li>
                                                    </template>
                                                    <template v-else>
                                                        <li>
                                                            {{ item.address }}
                                                        </li>
                                                    </template>
                                                </ul>
                                            </option>
                                        </template>
                                    </select> -->
                                    <textarea
                                        class="form-control"
                                        style="height: 80px"
                                        v-model="form.destination"
                                    ></textarea>
                                </div>
                            
                                <div class="col-md-6">
                                    <label class="form-label">Notes</label>
                                    <textarea
                                        class="form-control"
                                        style="height: 80px"
                                        v-model="form.notes"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="mt-3 text-end">
                                <button
                                    type="submit"
                                    :disabled="loading"
                                    class="btn btn-primary fw-semibold fs-14 px-4"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ValidationProvider,
    ValidationObserver,
    extend,
    configure,
} from "vee-validate";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import { mapActions, mapGetters, mapState } from "vuex";

import CustomerSelect from "./CustomerSelect";
import VendorSelect from "./VendorSelect";

configure({
    classes: {
        valid: "is-valid",
        invalid: "is-invalid",
        dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
        // ...
    },
});

extend("positive", (value) => {
    if (value >= 0) {
        return true;
    }

    return "This field must be a positive number";
});

export default {
    name: "AddShippingModal",
    props: ["shipping", "order", "po", "loading", "carriers","customerWarehouse","companyWarehouse"],
    components: {
        ValidationObserver,
        ValidationProvider,
        DatePicker,
        CustomerSelect,
        VendorSelect,
    },
    
    created() {},
    mounted() {

        

        let self = this;

        $("#addShippingModal").on("show.bs.modal", () => {

            this.bill_to_options = [
            {
                text: this.order.customer.company_name, // "test"
                value: this.order.customer.company_name.id           // 2483
            }
            ]
            
            

            if (self.shipping) {
                self.form.order_id = self.shipping.order_id;

                self.form.customer_id = self.shipping.customer_id;
                self.form.customer = self.shipping.customer;

                self.form.vendor_id = self.shipping.vendor_id;
                self.form.vendor = self.shipping.vendor;

                self.form.purchase_order_id = self.shipping.purchase_order_id;

                self.form.quotation_id = self.shipping.quotation_id;
                self.form.quotation = self.shipping.quotation;

                self.form.source = self.shipping.source;
                self.form.destination = self.shipping.destination;
                self.form.carrier_company = self.shipping.carrier_company;
                self.form.status = self.shipping.status;

                self.form.shipment_type = self.shipping.shipment_type;
                self.form.products = self.shipping.products;
                self.form.carrier_type = self.shipping.carrier_type;
                self.form.shipping_type = self.shipping.shipping_type;
                self.form.tracking_no = self.shipping.tracking_no;
                self.form.tracking_url = self.shipping.tracking_url;
                self.form.completed_at = self.shipping.completed_at;
                self.form.eta_departure = self.shipping.eta_departure;
                self.form.eta_arrival = self.shipping.eta_arrival;
                self.form.notes = self.shipping.notes;
                self.is_partially_shipped = self.shipping.is_partially_shipped;
            } else {
                self.form.order_id = self.order.id;
                self.form.purchase_order_id = self.po.id;
                self.form.customer_id = self.order.customer_id;

                if (self.order.is_stocking) {
                    if (self.order.warehouses && self.order.warehouses.length) {
                        if (self.order.warehouses[0].warehouse) {
                            self.form.destination = `${self.order.warehouses[0].warehouse.address} ${self.order.warehouses[0].warehouse.address2} ${self.order.warehouses[0].warehouse.city} ${self.order.warehouses[0].warehouse.state} ${self.order.warehouses[0].warehouse.post_code}`;
                        } else {
                            self.form.destination =
                                self.order.warehouses[0].address;
                        }
                    }
                } else {
                    if (
                        self.order.customer_warehouses &&
                        self.order.customer_warehouses.length
                    ) {
                        if (self.order.customer_warehouses[0].warehouse) {
                            self.form.destination = `${self.order.customer_warehouses[0].warehouse.address} ${self.order.customer_warehouses[0].warehouse.address2} ${self.order.customer_warehouses[0].warehouse.city} ${self.order.customer_warehouses[0].warehouse.state} ${self.order.customer_warehouses[0].warehouse.post_code}`;
                        } else {
                            self.form.destination =
                                self.order.customer_warehouses[0].address;
                        }
                    }
                }
            }
        });

        $(this.$refs.addShippingModal).on("hidden.bs.modal", function () {
            self.form = {
                order_id: null,
                customer: null,
                customer_id: null,
                vendor: null,
                vendor_id: null,
                purchase_order_id: null,
                source: null,
                destination: null,
                shipment_type: null,
                products: [],
                carrier_type: null,
                total_pallet_count:null,
                shipping_type: null,
                carrier_company: null,
                status: 1,
                tracking_no: null,
                tracking_url: null,
                completed_at: null,
                eta_departure: null,
                eta_arrival: null,
                notes: null,
                is_partially_shipped: false,
            };

            self.$refs.formValidation.reset();
        });
    },
    data() {
        return {
            final_destination:null,
            bill_to_options:[],
            tracking_no_label: "MBL NO.",
            allCarrier: [
                { id: "Maersk", text: "Maersk" },
                { id: "OOCL", text: "OOCL" },
                { id: "APL", text: "APL" },
                { id: "ONE", text: "ONE" },
                { id: "ZIM", text: "ZIM" },
                { id: "COSCO", text: "COSCO" },
                { id: "Hapag Lloyd", text: "Hapag Lloyd" },
                { id: "Evergreen", text: "Evergreen" },
                { id: "Turkon", text: "Turkon" },
                { id: "Transfer", text: "Transfer" },
                { id: "MSC", text: "MSC" },
                { id: "Wan Hai Lines", text: "Wan Hai Lines" },
                { id: "TS Lines", text: "TS Lines" },
                { id: "SM Line", text: "SM Line" },
                { id: "Yang Ming", text: "Yang Ming" },
                { id: "HMM", text: "HMM" },
                { id: "Hamburg SUD", text: "Hamburg SUD" },
                { id: "CMA CGM", text: "CMA CGM" },
                { id: "UPS", text: "UPS" },
                { id: "Fedex", text: "Fedex" },
                { id: "DHL", text: "DHL" },
                { id: "Other", text: "Other" },
            ],
            checkAll: false,
            shippingTypeOptions: [],
            form: {
                eta: null,
                etd: null,
                order_id: null,
                customer: null,
                customer_id: null,
                carrier_id: null,
                vendor: null,
                vendor_id: null,
                purchase_order_id: null,
                source: null,
                destination: null,
                shipment_type: null,
                products: [],
                carrier_type: null,
                shipping_type: null,
                carrier_company: null,
                status: 1,
                tracking_no: null,
                tracking_url: null,
                completed_at: null,
                eta_departure: null,
                eta_arrival: null,
                notes: null,
                is_partially_shipped: false,
            },
            customers: [],
            vendors: [],
            quotations: [],
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
        checkCaseNumber(index) {
            console.log("index", index);
            console.log("checkCaseNumber Products", this.form.products[index]);
            //console.log("event", event);
            // console.log(
            //     "this.form.products[index].pcs_per_case",
            //     this.form.products[index].pcs_per_case
            // );

            if(this.form.products[index].pcs_per_case != '' && this.form.products[index].cases_per_pallet){

                if(this.form.products[index].qty_unit.name == 'M Bags' || this.form.products[index].qty_unit.name == 'M Impressions'){
                    this.form.products[index].total_cases = Math.ceil((this.form.products[index].quantity) / (this.form.products[index].pcs_per_case));
                }
                else{
                    this.form.products[index].total_cases = Math.ceil(this.form.products[index].quantity / (this.form.products[index].pcs_per_case));
                }
                
                this.form.products[index].amount_pallet = Math.ceil(this.form.products[index].total_cases / this.form.products[index].cases_per_pallet);
                // Math.ceil(this.form.products[index].quantity / (this.form.products[index].cases_per_pallet * this.form.products[index].pcs_per_case));
            }
            
            // console.log(
            //     "calculate ",
            //     this.form.products[index].pcs_per_case * 50
            // );

            // this.form.products[index].cases_per_pallet =
            //     this.form.products[index].pcs_per_case * 50;
        },

         checkPerAmount(index) {
            console.log("index", index);
            //console.log("event", event);
            console.log(
                "this.form.products[index].pcs_per_case",
                this.form.products[index].pcs_per_case
            );

            // if(this.form.products[index].amount_per_pallet){

            //    this.form.products[index].total_amount_pallet = this.form.products[index].total_pallet * this.form.products[index].amount_per_pallet
            // }
            let i = 0;
            for(i = 0;i < this.form.products.length;i++){
                console.log("pallet product ",this.form.products[i])
            }
            // console.log(
            //     "calculate ",
            //     this.form.products[index].pcs_per_case * 50
            // );

            // this.form.products[index].cases_per_pallet =
            //     this.form.products[index].pcs_per_case * 50;
        },

        checkAllEvent(event) {
            this.po.products.forEach((x) => {
                this.selectProduct(x, event.target.checked);
            });
        },
        selectProductCheckbox(product, event) {
            this.selectProduct(product, event.target.checked);
        },
        selectProduct(product, checked) {
            if (checked === null) {
                checked = !(
                    this.form.products.filter((x) => x.id === product.id)
                        .length > 0
                );
            }

            if (checked) {
                 console.log("product",product);
                if(product.qty_unit.name == "M Bags" || product.qty_unit.name == "M Impressions"){

                   
                    let newQty = product.quantity * 1000;
                    product.quantity = newQty;
                }
                // console.log("product update",product);
                product.is_partially_shipped = false;
                this.form.products.push(product);
            } else {
                this.form.products = this.form.products.filter(
                    (x) => x.id !== product.id
                );
            }
        },
        removeProductCheckbox(product) {
            this.selectProduct(product, false);
        },
        customerSelected(event) {
            console.log(event);
            if (event != null) {
                this.form.customer = event;
                this.form.customer_id = event.id;
            } else {
                this.form.customer = null;
                this.form.customer_id = null;
            }
        },
        vendorSelected(event) {
            console.log(event);
            if (event != null) {
                this.form.vendor = event;
                this.form.vendor_id = event.id;
            } else {
                this.form.vendor = null;
                this.form.vendor_id = null;
            }
        },
        submitHandler() {
            this.$refs.formValidation.validate().then((success) => {
                if (!success) {
                    return;
                }

                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);

                if (this.shipping) {
                    return axios
                        .put(
                            window.route("updateShipping", {
                                id: this.order.id,
                                shipping_id: this.shipping.id,
                            }),
                            this.form,
                            {
                                validateStatus: function (status) {
                                    return status < 500; // Resolve only if the status code is less than 500
                                },
                            }
                        )
                        .then(({ data }) => {
                            if (
                                data.errors &&
                                Object.keys(data.errors).length
                            ) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage(
                                    "Shipping updated successfully!"
                                );
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit("updatedEvent", data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(
                                error.response && error.response.errorMessage
                                    ? error.response.errorMessage
                                    : error.message
                            );
                        })
                        .finally(() => {
                            self.setLoading(false);
                        });
                } else {
                    return axios
                        .post(
                            window.route("addShipping", { id: this.order.id }),
                            this.form,
                            {
                                validateStatus: function (status) {
                                    return status < 500; // Resolve only if the status code is less than 500
                                },
                            }
                        )
                        .then(({ data }) => {
                            if (
                                data.errors &&
                                Object.keys(data.errors).length
                            ) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage(
                                    "Shipping added successfully!"
                                );
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit("addedEvent", data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(
                                error.response && error.response.errorMessage
                                    ? error.response.errorMessage
                                    : error.message
                            );
                        })
                        .finally(() => {
                            self.setLoading(false);
                        });
                }
            });
        },
        warehouseChange(event, type) {
           // alert("sss"+event);
            if (event == "add_new") {
                
            } else {
                let warehouse = null;
                if(type == "billTo"){
                     warehouse = this.order.customer;
                    //  warehouse = this.customerWarehouses.find(
                    //     (x) => (x.id == event.target.value)
                    // );
                } else {
                    warehouse = this.companyWarehouse.find(
                        (x) => (x.id == event)
                    );
                }

                console.log("warehouse",warehouse);
                if(type == "billTo"){
                    // if (warehouse) {
                    //     let address = warehouse.contact_name+ '\n';
                    //     if (warehouse.contact_no) {
                    //         address += `, ${warehouse.contact_no}`+ '\n';
                    //     }
                    //     if (warehouse.state) {
                    //         address += `, ${warehouse.contact_no}`+ '\n';
                    //     }
                    //     if (warehouse.post_code) {
                    //         address += `, ${warehouse.contact_no}`;
                    //     }

                    //     this.newOrder[type][index].address = address;
                    // }
                     if (warehouse) {
                        let address = warehouse.company_name + '\n';
                        address += warehouse.address+ '\n';
                        if (warehouse.city) {
                            address += ` ${warehouse.city}`;
                        }
                        if (warehouse.state) {
                            address += ` ${warehouse.state}`;
                        }
                        if (warehouse.post_code) {
                            address += ` ${warehouse.post_code}`;
                        }
                        console.log("bill to ",warehouse);
                        this.form.destination = address;
                    }
                 }
                else {

                     if (warehouse) {
                        let address = warehouse.name+ '\n';
                        address += warehouse.address+ '\n';
                        
                    
                        if (warehouse.city) {
                            address += ' '+`${warehouse.city}`;
                        }
                        if (warehouse.state) {
                            address += ` ${warehouse.state}`;
                        }
                        if (warehouse.post_code) {
                            address += ' '+`${warehouse.post_code}`;
                        }

                        this.form.destination = address;
                        console.log("address",address)
                     }
                    //console.log("this.shippingForm[type][index].address",this.shippingForm[type][index].address);
                }
            }
        },
    },
    computed: {
        ...mapGetters(["commonErrors", "errorMessage", "successMessage"]),
    },
    watch: {
        "form.shipping_type": {
            handler: function (after, before) {
                if (after == "Courier") {
                   // this.tracking_no_label = "MBL NO.";
                } else {
                    //this.tracking_no_label = "MBL NO.";
                }
            },

            deep: true,
        },
        "form.carrier_company": {
            handler: function (after, before) {
                console.log("form.carrier_company : ", after);
            },

            deep: true,
        },
        "form.carrier_type": {
            handler: function (after, before) {
                if (after == 1) {
                    this.tracking_no_label = "Tracking";
                    //this.shippingTypeOptions = ['FCL','LCL','Parcel'];
                    this.shippingTypeOptions = ["Cargo", "Courier"];
                } else {
                    this.tracking_no_label = "BOL";
                    this.shippingTypeOptions = [
                        //"FCL",
                       //"LCL",
                        "Parcel",
                        "LCL",
                        "FCL 20",
                        "FCL 40",
                    ];
                }
                console.log("shippingTypeOptions", this.shippingTypeOptions);
                console.log("after :", after);
            },

            deep: true,
        },
        "form.customer_warehouse":{
            handler: function (after, before) {
                // if (after != null) {
                //     let code = after;
                //      //console.log(after, code);
                //      let carriers = this.customerWarehouse.filter(
                //          (x) => x.id == code
                //      );
                //     if (carriers.length) {
                //          this.form.destination = carriers[0].address + '\n ' + carriers[0].address2+ '\n ' + carriers[0].city + '\n ' + carriers[0].state+ '\n ' + carriers[0].post_code;
                         
                //      }
                //     console.log("new data ",carriers);
                // }
                //  console.log("form.customer_warehouse daat ",this.customerWarehouse);
                // console.log("form.customer_warehouse ",after);
            }
        },
        "form.company_warehouse":{
            handler: function (after, before) {
                
                // if (after != null) {
                //     let code = after;
                //      //console.log(after, code);
                //      let carriers = this.companyWarehouse.filter(
                //          (x) => x.id == code
                //      );
                //      if (carriers.length) {
                //          this.form.destination = carriers[0].address;
                         
                //      }

                //    //this.form.destination = carriers.address;
                //     console.log("new data ",carriers);
                // }
                // console.log("form.company_warehouse data ",this.companyWarehouse);
                // console.log("form.company_warehouse ",after);
            }
        },
         "form.tracking_no": {
            handler: function (after, before) {
                 console.log("this.carriers ", this.carriers);
                // this.form.carrier_company = null;
                 //this.form.carrier_id = null;
                 if (after != null && after.length >= 4) {
                     let code = after.substring(0, 4);
                     //console.log(after, code);
                     let carriers = this.carriers.filter(
                         (x) => x.code.toLowerCase() == code.toLowerCase()
                     );
                     //console.log(carriers)
                     if (carriers.length) {
                         this.form.carrier_company = carriers[0].name;
                         this.form.carrier_id = carriers[0].id;
                     }
                 }
             },
             deep: true,
         },
        "form.products": {
            handler: function (value, oldValue) {


                let i = 0;
                let totalPalet = 0;
                for(i = 0;i < this.form.products.length;i++){

                    totalPalet += this.form.products[i].amount_pallet;

                    console.log("pallet product ",this.form.products[i])
                }

                this.form.total_pallet_count = totalPalet;

                console.log("ii ", value);
                if (
                    value != null &&
                    this.po.products != null &&
                    this.po.products.length === value.length
                ) {
                    this.checkAll = true;
                } else {
                    this.checkAll = false;
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped></style>
